import { useId, useState } from 'react';

import './Accordion.css';

export type AccordionProps = {
  question: string;
  answer: string;
  defaultOpen?: boolean;
};

// Editorial accordion — single-open behaviour is delegated to the parent
// (FAQ list keeps shared state if needed). Defaults to closed except when
// `defaultOpen` is set on the first item to invite scanning.
export function Accordion({ question, answer, defaultOpen = false }: AccordionProps) {
  const [open, setOpen] = useState(defaultOpen);
  const generatedId = useId();
  const panelId = `accordion-panel-${generatedId}`;
  const buttonId = `accordion-button-${generatedId}`;

  return (
    <div className={`accordion${open ? ' is-open' : ''}`}>
      <button
        id={buttonId}
        type="button"
        className="accordion__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="accordion__question">{question}</span>
        <span className="accordion__icon" aria-hidden="true">
          {open ? '−' : '+'}
        </span>
      </button>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        hidden={!open}
        className="accordion__panel"
      >
        <p className="accordion__answer">{answer}</p>
      </div>
    </div>
  );
}
